import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';

function Achievements({ playerId }) {
  const [achievements, setAchievements] = useState([]);
  const [dfgDollars, setDfgDollars] = useState(0);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!playerId) return;
    const fetchData = async () => {
      try {
        const achRes = await fetch(`${API_BASE_URL}/achievements/${playerId}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!achRes.ok) throw new Error(await achRes.text());
        setAchievements(await achRes.json());

        const bankRes = await fetch(`${API_BASE_URL}/bank/${playerId}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!bankRes.ok) throw new Error(await bankRes.text());
        setDfgDollars((await bankRes.json()).dfgDollars);
      } catch (error) {
        setMessage('Error: ' + error.message);
      }
    };
    fetchData();
  }, [playerId]);

  const unlockAchievement = async (achievementId) => {
    try {
      const res = await fetch(`${API_BASE_URL}/unlock-achievement`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ playerId, achievementId })
      });
      if (!res.ok) throw new Error((await res.json()).error || 'Unlock failed');
      const data = await res.json();
      setMessage(data.message);
      setDfgDollars(data.dfgDollars);
      setAchievements(achievements.map(a => 
        a.achievementId === achievementId ? { ...a, unlocked: true } : a
      ));
    } catch (error) {
      setMessage('Error: ' + error.message);
    }
  };

  if (!playerId) return <p>Please log in.</p>;

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', color: '#333' }}>Achievements</h1>
      <p>DFG$: {dfgDollars}</p>
      {message && <p style={{ color: message.includes('Error') ? 'red' : 'green' }}>{message}</p>}
      <h2 style={{ color: '#4CAF50' }}>Achievements</h2>
      {achievements.length > 0 ? achievements.map(a => (
        <div key={a.achievementId} style={{ marginBottom: '15px', padding: '10px', background: '#f9f9f9', borderRadius: '5px' }}>
          <p style={{ margin: 0 }}>
            <strong>{a.name}</strong> - {a.description}{' '}
            {a.unlocked ? (
              <span style={{ color: '#4CAF50' }}> (Unlocked)</span>
            ) : (
              <>
                {a.canUnlock ? (
                  <button 
                    onClick={() => {
                      console.log(`Clicked Unlock for ${a.achievementId}`);
                      unlockAchievement(a.achievementId);
                    }} 
                    style={{ marginLeft: '10px', background: '#4CAF50', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px' }}
                  >
                    Unlock
                  </button>
                ) : (
                  <span style={{ color: '#888' }}> (Progress: {a.progress})</span>
                )}
              </>
            )}
          </p>
        </div>
      )) : <p>No achievements available.</p>}
    </div>
  );
}

export default Achievements;